export const KubernetesPortainerResourcePoolNameLabel = 'io.shbdeployer.kubernetes.resourcepool.name';

export const KubernetesPortainerResourcePoolOwnerLabel = 'io.shbdeployer.kubernetes.resourcepool.owner';

export const KubernetesPortainerNamespaceSystemLabel = 'io.shbdeployer.kubernetes.namespace.system';

/**
 * KubernetesResourcePool Model
 */
export function KubernetesResourcePool() {
  return {
    Namespace: {}, // KubernetesNamespace
    Quota: undefined, // KubernetesResourceQuota,
    Ingresses: [], // KubernetesIngress[]
    Yaml: '',
  };
}
